import BodyText from '@lyra/core/components/BodyText'
import Button from '@lyra/core/components/Button'
import DropdownButton from '@lyra/core/components/DropdownButton'
import BigNumberInput from '@lyra/core/components/Input/BigNumberInput'
import LabelText from '@lyra/core/components/LabelText'
import RowItemDEPRECATED from '@lyra/core/components/RowItemDEPRECATED'
import Section from '@lyra/core/components/Section'
import NetworkIcon from '@lyra/web/components/common/NetworkIcon'
import TokenIcon from '@lyra/web/components/common/TokenIcon'
import { DepositNetwork } from '@lyra/web/constants/chains'
import { DepositTokenId, tokenConfig, TokenId } from '@lyra/web/constants/tokens'
import { LyraFundingBalances } from '@lyra/web/constants/wallet'
import { formatDepositNetworkName } from '@lyra/web/utils/chains'
import {
  formatDepositTokenSymbol,
  formatTokenBalance,
  getTokenForDepositToken,
} from '@lyra/web/utils/tokens'

type Props = {
  selectedNetwork: DepositNetwork
  supportedNetworks: DepositNetwork[]
  tokenBalance: bigint
  balances: LyraFundingBalances
  supportedTokens: DepositTokenId[]
  selectedToken: TokenId
  selectedWithdrawToken: DepositTokenId
  amountInput: bigint
  fee?: bigint
  onChangeNetwork: (network: DepositNetwork) => void
  onChangeAmountInput: (amount: bigint) => void
  onChangeToken: (token: DepositTokenId) => void
}

export default function WithdrawModalRows({
  selectedNetwork,
  supportedNetworks,
  balances,
  tokenBalance,
  selectedToken,
  selectedWithdrawToken,
  supportedTokens,
  amountInput: withdrawAmountInput,
  fee,
  onChangeNetwork,
  onChangeAmountInput,
  onChangeToken,
}: Props) {
  return (
    <>
      <Section.YStack>
        <LabelText>Token</LabelText>
        <DropdownButton
          strategy="fixed"
          leftContent={<TokenIcon size={18} symbol={selectedWithdrawToken} />}
          size="lg"
          textAlign="left"
          label={formatDepositTokenSymbol(selectedWithdrawToken)}
        >
          {supportedTokens.map((depositTokenId) => {
            const tokenId = getTokenForDepositToken(depositTokenId)
            return (
              <DropdownButton.ListItem
                icon={<TokenIcon size={18} symbol={depositTokenId} />}
                label={formatDepositTokenSymbol(depositTokenId)}
                sublabel={formatTokenBalance(balances[tokenId].balanceBn, tokenId)}
                key={depositTokenId}
                isSelected={selectedWithdrawToken === depositTokenId}
                onPress={() => onChangeToken(depositTokenId)}
              />
            )
          })}
        </DropdownButton>
      </Section.YStack>
      <Section.YStack>
        <BigNumberInput
          decimals={tokenConfig[selectedToken].decimals}
          label="Amount"
          rightLabel={`Available: ${formatTokenBalance(tokenBalance, selectedToken)}`}
          value={withdrawAmountInput}
          onChangeValue={onChangeAmountInput}
          formatValue={(val) => formatTokenBalance(val, selectedToken)}
          size="lg"
          width="100%"
          rightContent={
            <Button
              size="sm"
              label="Max"
              onPress={() => onChangeAmountInput(tokenBalance)}
              isSelected={tokenBalance > BigInt(0) && tokenBalance === withdrawAmountInput}
            />
          }
        />
      </Section.YStack>
      <Section.YStack>
        <LabelText>To Network</LabelText>
        <DropdownButton
          strategy="fixed"
          leftContent={<NetworkIcon size={18} network={selectedNetwork} />}
          size="lg"
          textAlign="left"
          label={selectedNetwork}
        >
          {supportedNetworks.map((network) => (
            <DropdownButton.ListItem
              icon={<NetworkIcon network={network} />}
              label={formatDepositNetworkName(network)}
              key={network}
              onPress={() => onChangeNetwork(network)}
            />
          ))}
        </DropdownButton>
      </Section.YStack>
      <Section.XStack>
        <RowItemDEPRECATED
          label={<BodyText color="secondary">Network Fee</BodyText>}
          value={
            <BodyText>
              {fee !== undefined ? formatTokenBalance(fee, selectedToken) : '...'}
            </BodyText>
          }
        />
      </Section.XStack>
    </>
  )
}
